import { ManagedLeadDetail } from '../../services/api/managed-leads/managedLeads';
import { canUpdateManagedLead } from './managedLeadUpdateAvailability';

export interface ManagedLeadAppointmentRow {
  key: string;
  label: string;
  kind: 'date' | 'text';
}

/**
 * The appointment as the detail reads it. The keys are the semantic ones the
 * update contract already uses; the labels are the backoffice's own because the
 * box names the appointment in every stage, while the server publishes labels
 * only for the stages that collect it.
 */
export const MANAGED_LEAD_APPOINTMENT_ROWS: ManagedLeadAppointmentRow[] = [
  { key: 'appointmentDate', label: 'Data', kind: 'date' },
  { key: 'appointmentTime', label: 'Ora', kind: 'text' },
  { key: 'appointmentLocation', label: 'Luogo', kind: 'text' },
];

const APPOINTMENT_KEYS = new Set(
  MANAGED_LEAD_APPOINTMENT_ROWS.map((row) => row.key)
);

/**
 * Whether the box may offer its shortcut into the update form. The stage the
 * lead sits in has to be one that collects the appointment - the policy says
 * which, never the backoffice - and the update has to be savable at all, or the
 * pencil would open a form that ignores what it was clicked for.
 */
export const canEditManagedLeadAppointment = (detail: ManagedLeadDetail) =>
  canUpdateManagedLead(detail, detail.pendingDrop) &&
  (detail.requirements.fields ?? []).some((field) =>
    APPOINTMENT_KEYS.has(field.key)
  );
